import styled, { css, TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';
import { SPACING } from '~/common/layout-propertis/spacing';

import { Icon } from '../Icons';

export const Option = styled.li<{
  current: boolean;
  transparentBackground: boolean;
  hoverColor: TColorProp;
  withoutHoverCursor?: boolean;
  paddingLeft?: string;
}>`
  cursor: ${({ withoutHoverCursor }) =>
    withoutHoverCursor ? 'default' : 'pointer'};
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  padding: ${SPACING._8};
  gap: ${SPACING._6};
  border-radius: ${SPACING._4};
  transition: 200ms;
  max-height: 36px;
  background-color: ${({ theme, current, transparentBackground }) =>
    transparentBackground
      ? theme.transparent
      : current
      ? theme.neutral[900]
      : theme.neutral[950]};

  ${({ paddingLeft }) =>
    paddingLeft &&
    css`
      padding-left: ${paddingLeft};
    `}

  svg,
  div,
  span {
    transition: 200ms;
  }

  ${({ withoutHoverCursor, hoverColor, theme }) =>
    !withoutHoverCursor &&
    css`
      &:hover {
        background-color: ${getThemeColor(theme, hoverColor)};
        span {
          color: ${theme.neutral[50]};
        }
      }
    `}
`;

export const CustomArrow = styled(Icon)<{
  to: 'top' | 'bottom';
}>`
  transition: 200ms;
  margin-left: auto;
  ${({ to }) =>
    to === 'top'
      ? css`
          transform: rotate(-90deg);
        `
      : css`
          transform: rotate(90deg);
        `}
`;
